import { render, staticRenderFns } from "./AddName.Dialog.vue?vue&type=template&id=52c0e9cc&"
import script from "./AddName.Dialog.vue?vue&type=script&lang=js&"
export * from "./AddName.Dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports